
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","viewBox":"0 0 19 19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.49999 0C6.65958 0 4.34802 2.31087 4.34802 5.15204V14.9059C4.34802 15.2541 4.62976 15.5359 4.97802 15.5359C5.32604 15.5359 5.60778 15.2542 5.60778 14.9059V5.15204C5.60778 3.00592 7.35345 1.25979 9.49999 1.25979C11.6468 1.25979 13.3924 3.00592 13.3924 5.15204V15.2081C13.3924 16.6041 12.2563 17.7403 10.86 17.7403C10.8496 17.7403 10.8403 17.7458 10.8299 17.7464C10.8188 17.7458 10.8102 17.7403 10.7992 17.7403C9.40295 17.7403 8.26686 16.6041 8.26686 15.2081V9.17591C8.26686 8.49557 8.81977 7.94263 9.49999 7.94263C10.1804 7.94263 10.7333 8.49557 10.7333 9.17591V14.9059C10.7333 15.2541 11.0155 15.5359 11.3631 15.5359C11.7106 15.5359 11.9931 15.2542 11.9931 14.9059V9.17591C11.9931 7.80113 10.8748 6.68288 9.49999 6.68288C8.1254 6.68288 7.00711 7.80117 7.00711 9.17591V15.2081C7.00711 17.2986 8.70786 19 10.7991 19C10.8102 19 10.8188 18.9944 10.8299 18.9938C10.8403 18.9945 10.8496 19 10.8599 19C12.9507 19 14.6519 17.2987 14.6519 15.2081V5.15204C14.652 2.31087 12.3404 0 9.49999 0Z"}})])
          )
        }
      }
    